(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(function () {
            return factory();
        });
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory();
    } else {
        root.Trace = factory();
    }
})(this, function () {
    'use strict';
    var lineRx = /.*?(\w+:\/\/.*?\d+:\d+).*/;
    var EMPTY = '';
    var NL = '\n';
    var ERROR = 'Error';
    var $1 = '$1';

    function Trace (ns, err) {
        this.stack = (err.stack || EMPTY).split(NL);
        this.message = err.message || (ns + ERROR);
        this.file = (this.stack[1] || EMPTY).replace(lineRx, $1);
    }

    Trace.prototype = Object.create(Error.prototype);

    return Trace;
});
